    var $window = $(window);
    function checkWidth() {
        var windowsize = $window.width();
        if (windowsize > 520) {
          $(".desktophead").css("display","block");
          $(".textdesktp").css("display","block");
$(".mobilhead").css("display","none");
          $(".textmobil").css("display","none");
        }
      else{
                $(".desktophead").css("display","none");
          $(".textdesktp").css("display","none");
$(".mobilhead").css("display","block");
          $(".textmobil").css("display","block");}
    }
    checkWidth();
    $(window).resize(checkWidth);